// import React, { Component } from "react";
// import { Col, Row, Card } from "react-bootstrap";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
// import Alert from "sweetalert2";
// class EventCalendar extends Component {
//    state = {
//       calendarEvents: [
//          {
//             title: "Lunch",
//             start: new Date("2021-09-05 00:00"),
//             id: "12344522",
//          },
//          {
//             title: "Repeating Event",
//             start: new Date("2021-09-12 00:00"),
//             end: new Date("2021-09-13 10:00"),
//             id: "12322511",
//          },

//          {
//             title: "Atlanta Monster",
//             start: new Date("2021-09-16 00:00"),
//             id: "12311523",
//          },
//          {
//             title: "Slot",
//             start: new Date("2021-09-21 00:00"),
//             end: new Date("2021-09-22 10:00"),
//             id: "12334566",
//          },
//          {
//             title: "My Favorite",
//             start: new Date("2021-10-01 00:00"),
//             id: "12343210",
//          },
//          {
//             title: "Birthday",
//             start: new Date("2021-10-10 00:00"),
//             id: "12344577",
//          },
//       ],
//       events: [
//          { title: "Menu 1", id: "1" },
//          { title: "Menu 2", id: "2" },
//          { title: "Menu 3", id: "3" },
//          { title: "Menu 4", id: "4" },
//          { title: "Menu 5", id: "5" },
//       ],
//    };

//    /**
//     * adding dragable properties to external events through javascript
//     */
//    componentDidMount() {
//       let draggableEl = document.getElementById("external-events");
//       new Draggable(draggableEl, {
//          itemSelector: ".fc-event",
//          eventData: function (eventEl) {
//             let title = eventEl.getAttribute("title");
//             let id = eventEl.getAttribute("data");
//             return {
//                title: title,
//                id: id,
//             };
//          },
//       });
//    }

//    /**
//     * when we click on event we are displaying event details
//     */
//    eventClick = (eventClick) => {
//       Alert.fire({
//          title: eventClick.event.title,
//          html:
//             `<div className="table-responsive">
//       <table className="table">
//       <tbody>
//       <tr >
//       <td>Title</td>
//       <td><strong>` +
//             eventClick.event.title +
//             `</strong></td>
//       </tr>
//       <tr >
//       <td>Start Time</td>
//       <td><strong>
//       ` +
//             eventClick.event.start +
//             `
//       </strong></td>
//       </tr>
//       </tbody>
//       </table>
//       </div>`,

//          showCancelButton: true,
//          confirmButtonColor: "#d33",
//          cancelButtonColor: "#3085d6",
//          confirmButtonText: "Remove Event",
//          cancelButtonText: "Close",
//       }).then((result) => {
//          if (result.value) {
//             eventClick.event.remove(); // It will remove event from the calendar
//             Alert.fire("Deleted!", "Your Event has been deleted.", "success");
//          }
//       });
//    };

//    render() {
//       return (
//          <div className="animated fadeIn demo-app">
//             <Row>

//                <Col lg={3}>
//                   <Card>
//                      <div className="card-header border-0 pb-0">
//                         <h4 className="text-black fs-20 mb-0">Events</h4>
//                      </div>
//                      <Card.Body>
//                         <div id="external-events">
//                            {this.state.events.map((event) => (
//                               <div
//                                  className="fc-event mt-0 ms-0 mb-2 btn btn-block btn-primary"
//                                  title={event.title}
//                                  data={event.id}
//                                  key={event.id}
//                               >
//                                  {event.title}
//                               </div>
//                            ))}
//                         </div>
//                      </Card.Body>
//                   </Card>
//                </Col>

//                <Col lg={9}>
//                   <Card>
//                      <Card.Body>
//                         <div className="demo-app-calendar" id="mycalendartest">
//                            <FullCalendar
//                               defaultView="dayGridWeek"
//                               header={{
//                                  left: "prev,next today",
//                                  center: "title",
//                                  right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
//                               }}
//                               rerenderDelay={10}
//                               eventDurationEditable={false}
//                               editable={true}
//                               droppable={true}
//                               plugins={[
//                                  dayGridPlugin,
//                                  timeGridPlugin,
//                                  interactionPlugin,
//                               ]}
//                               ref={this.calendarComponentRef}
//                               weekends={this.state.calendarWeekends}
//                               events={this.state.calendarEvents}
//                               eventDrop={this.drop}
//                               // drop={this.drop}
//                               eventReceive={this.eventReceive}
//                               eventClick={this.eventClick}
//                            // selectable={true}
//                            />
//                         </div>
//                      </Card.Body>
//                   </Card>
//                </Col>
//             </Row>
//          </div>
//       );
//    }
// }
// export default EventCalendar;

import React, { Component } from 'react';
import { DayPilot, DayPilotCalendar, DayPilotNavigator } from "@daypilot/daypilot-lite-react";
// import "./CalendarStyles.css";

const styles = {
   wrap: {
      display: "flex"
   },
   left: {
      marginRight: "10px"
   },
   main: {
      flexGrow: "1"
   }
};

class EventCalendar extends Component {

   constructor(props) {
      super(props);
      this.calendarRef = React.createRef();
      this.state = {
         viewType: "Week",
         durationBarVisible: false,
         timeRangeSelectedHandling: "Enabled",
         onTimeRangeSelected: async args => {
            const dp = this.calendar;
            const modal = await DayPilot.Modal.prompt("Create", "Slot 1");
            dp.clearSelection();
            if (!modal.result) { return; }
            dp.events.add({
               start: args.start,
               end: args.end,
               id: DayPilot.guid(),
               text: modal.result
            });
         },
         eventDeleteHandling: "Update",
         onEventClick: async args => {
            const dp = this.calendar;
            const modal = await DayPilot.Modal.prompt("Update", args.e.text());
            if (!modal.result) { return; }
            const e = args.e;
            e.data.text = modal.result;
            dp.events.update(e);
         },
      };
   }

   get calendar() {
      return this.calendarRef.current.control;
   }

   componentDidMount() {

      const events = [
         {
            id: 1,
            text: "Slot 1",
            start: "2022-12-16T10:30:00",
            end: "2022-12-16T13:00:00"
         },
         {
            id: 2,
            text: "Slot 2",
            start: "2022-12-16T06:30:00",
            end: "2022-12-16T08:30:00",
            backColor: "#6aa84f"
         },
         {
            id: 3,
            text: "Slot 1",
            start: "2022-12-17T06:00:00",
            end: "2022-12-17T10:00:00",
            backColor: "#f1c232"
         },
         {
            id: 4,
            text: "Slot 2",
            start: "2022-12-17T11:30:00",
            end: "2022-12-17T14:30:00",
            backColor: "#cc4125"
         },
      ];
      const startDate = new Date();
      this.calendar.update({ startDate, events });
   }

   render() {
      return (
         <div>
            {/* // <div style={styles.wrap}> */}
            {/* <div style={styles.left}> */}

            < DayPilotNavigator
               selectMode={"week"}
               showMonths={false}
               // skipMonths={1}
               startDate={new Date()}
               selectionDay={new Date()}
               onTimeRangeSelected={args => {
                  this.calendar.update({
                     startDate: args.day
                  });
               }
               }
            />
            {/* </div> */}

            {/* <div style={styles.main}> */}

            < DayPilotCalendar
               {...this.state}
               ref={this.calendarRef}
            />
            {/* </div> */}

            {/* // </div> */}
         </div>
      );
   }
};
export default EventCalendar;